import { useState } from 'react';
import { SelectedProperty } from 'src/pages/Reporting/Forms/OccupancyDeficiencyForm/OccupancyDeficiencyForm';
import {
  ReportingFormState,
  SelectedValue,
} from 'src/pages/Reporting/ReportingFormTypes';

export interface IUseReportingFormStateReturn {
  formState: ReportingFormState;
  selectedProperties: SelectedProperty[];

  updateReportType: (nextType: string) => void;
  updateSelectedValues: (nextSelectedValues: SelectedValue[]) => void;
  updateFromDate: (nextFromDate: Date | null) => void;
  updateToDate: (nextToDate: Date | null) => void;
  updateSelectedProperties: (nextSelectedProperties: SelectedProperty[]) => void;
  resetFormState: () => void;
}

const INITIAL_FORM_STATE: ReportingFormState = {
  propertyId: '',
  selectedValues: [],
  fromDate: null,
  toDate: new Date(),
  type: 'Reporting',
};

export const useReportingFormState = (): IUseReportingFormStateReturn => {
  const [formState, setFormState] =
    useState<ReportingFormState>(INITIAL_FORM_STATE);

  const [selectedProperties, setSelectedProperties] = useState<
    SelectedProperty[]
  >([]);

  const updateReportType = (nextType: string): void => {
    setFormState((prev: ReportingFormState) => ({ ...prev, type: nextType }));
  };

  const updateSelectedValues = (
    nextSelectedValues: SelectedValue[]
  ): void => {
    setFormState((prev: ReportingFormState) => ({
      ...prev,
      selectedValues: nextSelectedValues,
    }));
  };

  const updateFromDate = (nextFromDate: Date | null): void => {
    setFormState((prev: ReportingFormState) => ({
      ...prev,
      fromDate: nextFromDate,
    }));
  };

  const updateToDate = (nextToDate: Date | null): void => {
    setFormState((prev: ReportingFormState) => ({
      ...prev,
      toDate: nextToDate,
    }));
  };

  const updateSelectedProperties = (
    nextSelectedProperties: SelectedProperty[]
  ): void => {
    setSelectedProperties(nextSelectedProperties);
  };

  const resetFormState = (): void => {
    setFormState(INITIAL_FORM_STATE);
    setSelectedProperties([]);
  };

  return {
    formState,
    selectedProperties,

    updateReportType,
    updateSelectedValues,
    updateFromDate,
    updateToDate,
    updateSelectedProperties,
    resetFormState,
  };
};
